import React, { useState, useEffect, useCallback } from 'react';
import { Auth } from 'aws-amplify';
import { DataGridPro, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';import { ContentTitle } from '../ui/styled';
import BackIcon from '../common/Back/BackIcon';
import PageHeading from '../common/Heading/PageHeading';
import { CDCR_LIST_URL, paginationSize, dateFormat } from '../../constants';
import { getCdcrList } from './services/cdcrApi';
import { commonQueryParams } from '../../services/QueryParams/QueryParams';
import { LeftGrid } from '../Episode/Episode.Styled';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom'
import moment from 'moment';

const CdcrReportList = (props) => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [user, setUser] = useState(null);
  const [searchCdcrReportList, setSearchCdcrReportList] = useState('');
  const [cdcrReportList, setCdcrReportList] = useState({
    isLoading: false,
    data: [],
    //total: 0,
    page: 1,
    pageSize: 10,
    sortModel: '',
    filterModel: {items: []}
  });

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    cdcrReportList.filterModel,
  ]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const fetchData = async () => {
    let validStartFilter = false;
    let validEndFilter = false;

    //console.log(cdcrReportList.filterModel.items);
    for (const filter of cdcrReportList.filterModel.items) {
      console.log(filter);
      if (filter.columnField === 'osaP_WkID' && filter.value) {
        validStartFilter = true;
        setStartDate(filter.value);
      }
      if (filter.columnField === 'osaP_EndWkID' && filter.value) {
        validEndFilter = true;
        setEndDate(filter.value);
      }
    }

    if (validStartFilter && validEndFilter) {
      setCdcrReportList((old) => ({ ...old, isLoading: true }));
      const commonParams = commonQueryParams(
        CDCR_LIST_URL,
        '',
        cdcrReportList
      );
      const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
      const CDCRList = await getCdcrList({
        commonParams,
        authorization,
      });
      setCdcrReportList((old) => ({
        ...old,
        ...CDCRList,
      }));
    }  
  };

  const columnsData = [
    { field: 'osapid', headerName: 'ID', flex: 1, filterable: false },
    { field: 'osaP_WkID', headerName: 'Start Date', type: 'date', flex: 1, valueFormatter: params => new Date(params?.value).toLocaleDateString() },
    { field: 'osaP_EndWkID', headerName: 'End Date', type: 'date', flex: 1, valueFormatter: params => new Date(params?.value).toLocaleDateString() },
    { field: 'osaP_PRt_GndID', headerName: 'Gnd', flex: 1, filterable: false },
    { field: 'osaP_PrtKey', headerName: 'Participant Key', flex: 1, filterable: false },
    { field: 'osaP_PrtID', headerName: 'Prt Id', flex: 1, filterable: false },
    { field: 'osaP_EpdID', headerName: 'Episode Id', flex: 1, filterable: false },
    { field: 'osaP_AthTyp_TypDscID', headerName: 'Ath Type', flex: 1, filterable: false },
    { field: 'osaP_Cbo_ModID', headerName: 'Mod Id', flex: 1, filterable: false },
    { field: 'osaP_CboDcpYN', headerName: 'Ded Cap?', flex: 1, type: 'boolean', filterable: false },
    { field: 'osapPopYN', headerName: 'Beg of Week?', flex: 1, type: 'boolean', filterable: false },
    { field: 'osapAdmYN', headerName: 'Admit?', flex: 1, type: 'boolean', filterable: false },
    { field: 'osapDchYN', headerName: 'Discharge?', flex: 1, type: 'boolean', filterable: false },
  ];

  const handleFilterChange = useCallback((filterModel) => {
    // Here you save the data you need from the filter model
    //console.log(filterModel);
    setCdcrReportList((old) => ({ ...old, filterModel: {...filterModel} }));
  }, []);

  const ExportToolbar = () => {
    return (
      <Box pt={1} sx={{ flexGrow: 1, backgroundColor: '#747070' }}>
        <Grid container spacing={1}>
          <Grid item xs={11}>
          </Grid>
          <Grid item xs={1}>
            { cdcrReportList.data.length > 0 &&  
              <GridToolbarContainer>
                <GridToolbarExport />
              </GridToolbarContainer>
            }  
          </Grid>
        </Grid>    
      </Box>  
    );
  };

  return (
    <>
      <Box>
      <ContentTitle container>
      <Grid item xs={2}>
        <Box style={{ display: 'flex', alignItems: 'center' }}>
          <BackIcon />
          <PageHeading title={'Continuing Care Report ' + (startDate && endDate ? moment(startDate).format(dateFormat) + ' - ' + moment(endDate).format(dateFormat) : ' (filter Start and End Date to generate report data)')} />
        </Box>
      </Grid>
      <Grid item xs={8}>
        <Box style={{ alignItems: 'center' }}>
          <Typography variant='h4' align='center'>{'Continuing Care Report ' + (startDate && endDate ? moment(startDate).format(dateFormat) + ' - ' + moment(endDate).format(dateFormat) : ' (filter Start and End Date to generate report data)')}</Typography>
        </Box>
      </Grid>      
      { cdcrReportList.data.length > 0 &&
        <LeftGrid item xs={2}>
          <Link to={"/cdcr/print/"} state={{ startDate: startDate, endDate: endDate }}>
            <Button
              variant='contained'
              style={{ justifyContent: 'flex-end' }}
            >
              Print Report
            </Button>
          </Link>  
        </LeftGrid>
      }  
      </ContentTitle>
      </Box>

      <DataGridPro
        initialState={{
          columns: {
            columnVisibilityModel: {
              // Hide these column(s)
              osapid: false,
            }},
        }}
        filterMode="server"
        getRowId={(row) => row.osapid}
        onFilterModelChange={handleFilterChange}
        autoHeight
        getRowHeight={() => 'auto'}
        columns={columnsData}
        rows={cdcrReportList.data}
        pageSize={cdcrReportList.pageSize}
        page={cdcrReportList.page - 1}
        //rowCount={cdcrReportList.total}
        //paginationMode='server'
        //sortingMode='server'
        onPageSizeChange={(newPageSize) =>
          setCdcrReportList((old) => ({ ...old, pageSize: newPageSize }))
        }
        onPageChange={(newPage) => {
          setCdcrReportList((old) => ({ ...old, page: newPage + 1 }));
        }}
        rowsPerPageOptions={paginationSize}
        components={{ Toolbar: ExportToolbar }}
        //pagination
        //components={{ Toolbar: QuickSearchToolbar }}
        //experimentalFeatures={{ newEditingApi: true }}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        }
        loading={cdcrReportList.isLoading}
      />
    </>
  );
};
export default CdcrReportList;
